import React from 'react';
import { 
	Modal,
} from 'react-bootstrap';
import { 
	func, 
	object,
	bool
} from 'prop-types';
import TextButton from '../../atoms/TextButton/index';
import ContainedButton from '../../atoms/ContainedButton/index';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import Score from '../../molecules/Score/index';

const QuizResultModal = ({show,score,onSave,onClose,t}) => {
	return (
		<Modal
			show={show}
		>
			<Modal.Header>
				<Modal.Title>{t('play-quiz.FinishTitle')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Score score={score}/>
			</Modal.Body>
			<Modal.Footer>
				<ContainedButton onClick={onSave}>SAVE</ContainedButton>
				<TextButton onClick={onClose}>{'Don\'t Save'}</TextButton>
			</Modal.Footer>
		</Modal>
	);
};

QuizResultModal.propTypes = {
	show : bool,
	score : object,
	onSave : func,
	onClose : func,
	t : func.isRequired
};

export default withNamespaces()(QuizResultModal);